<template>
  <div class="content">
    <h1 class="content__title" v-text="texts.title"></h1>
    <span class="content__details" v-text="texts.subtitle"></span>
    <div class="content__container">
      <main class="main">
        <section class="main__section">
          <h2 class="main__title">Datos de la Galería</h2>

          <div class="waiting" v-if="loading">
            <img src="/static/img/waiting.gif" alt="Cargando Información" class="waiting__image">
          </div>

          <form class="form" @submit.prevent="saveGallery" v-if="!loading">
            <div class="form__fielset">

              <div class="form__container form__container--short">
                <label for="name" class="form__label form__label--required">Nombre de la Galería (Uso interno)</label>
                <input type="text" class="form__input" name="name" id="name" placeholder="Nombre de la Galería" v-model="gallery.name" v-validate="validation.name">
                <span v-show="errors.has('name')" class="form__alert">{{ errors.first('name') }}</span>
              </div>

              <div class="form__container form__container--wide">
                <label for="title_es" class="form__label">Título de la Galería</label>
                <input type="text" class="form__input" name="title_es" id="title_es" placeholder="Título de la Galería" v-model="gallery.title_es" v-validate="validation.title_es">
                <span v-show="errors.has('title_es')" class="form__alert">{{ errors.first('title_es') }}</span>
              </div>

              <div class="form__container form__container--wide">
                <label for="last_name" class="form__label">Cuerpo de texto de la Galería</label>
                <textarea class="form__input" name="description_es" id="description_es" placeholder="Cuerpo de texto de la galería" v-model="gallery.description_es" v-validate="validation.description_es"></textarea>
                <span v-show="errors.has('description_es')" class="form__alert">{{ errors.first('description_es') }}</span>
              </div>

              <div class="form__container form__container--half">
                <label for="cover" class="form__label">Cover de la Galería</label>
                <img v-if="thumb" :src="thumb" alt="" class="form__thumb">
                <button class="btn btn--regular btn__default" @click.prevent="addCover">Agregar Imagen</button>
                <button v-if="gallery.cover" @click.prevent="removeImage" class="btn btn__transparent btn--regular">Quitar imagen</button>
                <span v-show="errors.has('cover')" class="form__alert">{{ errors.first('cover') }}</span>
              </div>

              <div class="form__container form__container--small">
                <label for="position" class="form__label">Posición</label>
                <input type="text" class="form__input" name="position" id="position" placeholder="Posición" v-model="gallery.position" v-validate="validation.position">
                <span v-show="errors.has('position')" class="form__alert">{{ errors.first('position') }}</span>
              </div>

              <div class="form__container form__container--short">
                <label for="status_id" class="form__label form__label--required">Estatus</label>
                <div class="form__select-container">
                  <select name="status_id" id="status_id" class="form__select" v-validate="validation.estatus_id" v-model="gallery.status_id">
                    <option :value="null">Seleccionar Estatus</option>
                    <option v-for="(status, index) in statusList" :key="index" :value="status.id" v-text="status.name"></option>
                  </select>
                </div>
                <span v-show="errors.has('status_id')" class="form__alert">{{ errors.first('status_id') }}</span>
              </div>

              <div class="form__container form__container--short">
                <label for="type_id" class="form__label form__label--required">Grupo de Galería</label>
                <div class="form__select-container">
                  <select name="type_id" id="type_id" class="form__select" v-validate="validation.type_id" v-model="gallery.type_id">
                    <option :value="null">Seleccionar Grupo</option>
                    <option v-for="(type, index) in types" :key="index" :value="type.id" v-text="type.name"></option>
                  </select>
                </div>
                <span v-show="errors.has('type_id')" class="form__alert">{{ errors.first('type_id') }}</span>
              </div>

              <input type="submit" class="btn btn__default btn--regular" :value="texts.submit">

            </div>
          </form>
        </section>
      </main>
      <aside class="sidebar">
        <h2 class="sidebar__title">OPCIONES</h2>
        <router-link class="btn btn--small btn__default" :to="{name: 'galleryList'}">Lista de Galerías</router-link>
        <router-link v-if="$route.name === 'galleryEdit'" class="btn btn--small btn__default" :to="{name: 'galleryNew'}">Nueva Galería</router-link>
      </aside>
    </div>
    <popup-viewer name="cover" @close="mediaManager = false" v-if="mediaManager"></popup-viewer>
  </div>
</template>

<script>
import httpService from '@/api/request'
import {validation, GalleryFields, statusList, texts} from './mocks'
import popupViewer from '@/components/media/popup'
import {config} from '@/assets/js/config/base'
export default {
  mixins: [httpService],
  components: {popupViewer},
  data: function () {
    return {
      validation: validation,
      gallery: null,
      types: [],
      statusList: statusList,
      mediaManager: false,
      thumb: config.local.noImage
    }
  },
  created: function () {
    this.start()
  },
  mounted: function () {
    this.$on('cover', cover => {
      this.gallery.cover = JSON.stringify(cover)
      this.thumb = cover.images.thumb[0]
      this.mediaManager = false
    })
  },
  watch: {
    '$route.path': function () {
      this.start()
    }
  },
  methods: {
    start: function () {
      this.getTypes()
      if (this.galleryId) {
        this.getGallery()
      }
      if (!this.galleryId) {
        this.thumb = config.local.noImage
        this.gallery = new GalleryFields()
      }
    },
    addCover: function () {
      this.mediaManager = true
    },
    removeImage: function () {
      this.thumb = config.local.noImage
      this.gallery.cover = null
    },
    getGallery: function () {
      let httpRequest = {
        params: '',
        module: 'galleries'
      }
      this.getById(this.galleryId, httpRequest)
        .then(
          gallery => {
            this.gallery = gallery.data
            if (gallery.data.cover) {
              let thumb = JSON.parse(gallery.data.cover)
              this.thumb = thumb.images.thumb[0]
            }
          }
        )
        .catch(
          () => {
            this.$router.push({name: 'galleryNew'})
          }
        )
    },
    getTypes: function () {
      let httpRequest = {
        params: '',
        module: 'gallery_types'
      }
      this.get(httpRequest)
        .then(
          types => {
            this.types = types.data
          }
        )
    },
    saveGallery: function () {
      this.$validator.validateAll()
        .then(
          response => {
            if (response) {
              let httpRequest = {
                params: '',
                module: 'galleries',
                element: this.gallery
              }
              let request
              if (this.$route.name === 'galleryEdit') {
                request = this.put(this.galleryId, httpRequest)
              } else if (this.$route.name === 'galleryNew') {
                request = this.post(httpRequest)
              }
              request.then(
                response => {
                  this.$store.commit('notificate', {
                    title: this.texts.messages.success.title,
                    text: this.texts.messages.success.text,
                    type: 'success'
                  })
                  if (this.$route.name === 'galleryNew') {
                    this.$router.push({name: 'galleryEdit', params: {id: response.data.current_id}})
                  }
                }
              )
            } else {
              this.$store.commit('notificate', {
                title: 'CAMPOS REQUERIDOS',
                text: 'Por favor, revise el formulario, existen campos requeridos que no han sido completados.',
                type: 'warn'
              })
            }
          }
        ).catch(
          error => {
            console.log(error)
          }
        )
    }
  },
  computed: {
    galleryId: function () {
      return this.$route.params.id
    },
    loading: function () {
      return this.$route.params.id && !this.gallery
    },
    texts: function () {
      return texts[this.$route.name]
    }
  }
}
</script>

<style lang="sass">
@import "../../assets/sass/objects/_btns"
@import "../../assets/sass/components/layout/_forms"
</style>



// WEBPACK FOOTER //
// src/components/galleries/edit.vue